import React from "react";
import { observer } from "mobx-react-lite";
import store from "store";
import stylesLess from "./index.module.less";
import { get_advertising } from "api/uaapi/user";
import sessionStorage from "utils/sessionStorage";
import { message } from "antd";
import { Hooks } from "@xt/xtbase";
const {useIntl} = Hooks;

export default observer(function Layout({ countryInfo, children }) {
  const intl = useIntl();
  const isDark = store?.app?.isDark ?? true;

  const [state_ad, setState_ad] = React.useState(null);

  React.useEffect(() => {
    // if (window === undefined) return;
    // console.log("addddd", { lang: appState.lang, countryInfo });
    const countryObj =
      countryInfo === undefined
        ? sessionStorage.get("countryInfo")
        : countryInfo;
    if (!countryObj) return;

    const id = countryObj.id + "";
    if (id) {
      get_advertising(id).then((data) => {
        if (data && data.isDisplay) setState_ad(data);
        else setState_ad(null);
      });
    }
  }, [countryInfo]);

  return (
    <div className={`${stylesLess.main} ${isDark ? "dark" : "light"}`}>
      <div className={"iSpaceBefore"}></div>
      <div className={"iWin"}>{children}</div>
      {/*<div className={"iSpaceMiddle"}></div>*/}
      <div className={"iAd"}>
        {state_ad && (
          <>
            {!!state_ad.isLogin && (
              <div
                style={{
                  backgroundImage: `url(${state_ad.advertisingImageHref})`,
                }}
                onClick={() =>
                  state_ad.advertisingHref &&
                  message.warn(
                    intl.formatMessage({ id: "register.adDisabledTip" })
                  )
                }
              ></div>
            )}
            {!state_ad.isLogin &&
              (state_ad.advertisingHref ? (
                <a
                  href={
                    (/^(http:|https:)?\/\/.+/.test(state_ad.advertisingHref)
                      ? ""
                      : "//") + state_ad.advertisingHref
                  }
                  target={"_blank"}
                  rel="noreferrer"
                  style={{
                    backgroundImage: `url(${state_ad.advertisingImageHref})`,
                  }}
                ></a>
              ) : (
                <div
                  style={{
                    backgroundImage: `url(${state_ad.advertisingImageHref})`,
                  }}
                ></div>
              ))}
          </>
        )}
      </div>
      <div className={"iSpace"}></div>
    </div>
  );
})
